import gql from 'graphql-tag'

const products = gql`
  query products(
    $pagination: pagination!
    $search: String
    $filter: filterProduct
    $workspace_id: Float!
  ) {
    products(
      pagination: $pagination
      search: $search
      filter: $filter
      workspace_id: $workspace_id
    ) {
      count
      products {
        id
        name
        description
        code_sku
        price
        status
        stock
        photo {
          id
          photo
          order_photo
        }
        created_at
        updated_at
        deleted_at
      }
    }
  }
`

export default products
